import { NavigationRoutes } from 'common/constants';
import { DocumentTypeEnum } from 'common/constants/enum';
import Separator from 'components/common/separator';
import Text from 'components/elements/text';
import {
  FullContainer,
  HalfContainer,
  SectionContainer,
} from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import { NavigationProps } from 'types';

import BirthdayScheduleTable from './tables/birthday-schedule-table';
import DocumentScheduleTable from './tables/document-schedule-table';
import FlightScheduleTable from './tables/flight-schedule-table';
import HotelScheduleTable from './tables/hotel-schedule-table';

export type CustomerRelationOfficerParams = null;

export default function CustomerRelationOfficer(
  props: NavigationProps<NavigationRoutes.Cro>,
) {
  const { t } = useTranslation();
  return (
    <FullContainer>
      <Text variant="HeadingSmall">{t('navigation:cro')}</Text>
      <Separator gap={24} />
      <FlightScheduleTable />
      <Separator gap={24} />
      <HotelScheduleTable />
      <Separator gap={24} />
      <SectionContainer>
        <HalfContainer>
          <DocumentScheduleTable documentType={DocumentTypeEnum.Passport} />
        </HalfContainer>
        <Separator gap={24} />
        <HalfContainer>
          <DocumentScheduleTable documentType={DocumentTypeEnum.Visa} />
        </HalfContainer>
      </SectionContainer>
      <Separator gap={24} />
      <SectionContainer>
        <HalfContainer>
          <DocumentScheduleTable documentType={DocumentTypeEnum.ApecCard} />
        </HalfContainer>
        <Separator gap={24} />
        <HalfContainer>
          <DocumentScheduleTable documentType={DocumentTypeEnum.Insurance} />
        </HalfContainer>
      </SectionContainer>
      <Separator gap={24} />
      <SectionContainer>
        <HalfContainer>
          <BirthdayScheduleTable />
        </HalfContainer>
      </SectionContainer>
      <Separator gap={24} />
    </FullContainer>
  );
}
